import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'react-final-form';

import classNames from 'classnames';

import {Button} from '../';
import {MAX_NAME_LEN} from '../../../configs/constants';

import {
  fieldIsRequired,
} from '../../../configs/messages';

export default class TextField extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    validatorsArray: PropTypes.arrayOf(PropTypes.func),
    label: PropTypes.string.isRequired,
    labelSize: PropTypes.string,
    maxLength: PropTypes.number,
    inputType: PropTypes.string,
    required: PropTypes.bool,
    rowGap: PropTypes.string,
    placeholder: PropTypes.string,
    isRow: PropTypes.bool,
    labelClass: PropTypes.string,
    inputClass: PropTypes.string,
    errorPosition: PropTypes.string,
    readOnly: PropTypes.bool,
    asterisk: PropTypes.bool,
  };

  static defaultProps = {
    validatorsArray: [],
    inputType: 'text',
    labelSize: '',
    maxLength: MAX_NAME_LEN,
    required: false,
    rowGap: 's',
    placeholder: '',
    isRow: false,
    labelClass: '',
    inputClass: '',
    readOnly: false,
    errorPosition: 'right',
    asterisk: false,
  };

  constructor(props) {
    super(props);

    const {inputType} = this.props;

    this.state = {
      type: inputType,
    };
  }

  requiredValidator = value => (value ? null : fieldIsRequired)

  togglePassword = () => {
    const {type} = this.state;
    this.setState({type: type === 'text' ? 'password' : 'text'});
  }

  composeValidators = (...validators) => (value, allValues) =>
    validators.reduce((error, validator) =>
      error || validator(value, allValues, this.props.label), undefined);

  renderRevealIcon = () => {
    const {
      inputType,
    } = this.props;
    const {type} = this.state;
    const icon = type === 'password' ? 'eye' : 'eye-slash';
    return (
      inputType === 'password' ?
        <Button
          tabIndex={-1}
          className="form__input-reveal"
          handler={this.togglePassword}
          icon={icon}
          theme="plain"
        /> :
        null
    );
  }

  renderFormRow = ({input, ...rest}) => {
    const {type} = this.state;
    const {
      maxLength,
      name,
      placeholder,
      labelClasses,
      meta,
      label,
      formRowClasses,
      inputClasses,
      readOnly,
      errorClasses,
      asterisk,
      required,
    } = rest;
    const onBlur = () => {
      input.onChange(input.value.trim());
      input.onBlur();
    };

    return (
      <div className={formRowClasses}>
        <label className={labelClasses} htmlFor={name}>
          {label}
          {asterisk && required && <span className="form__label_asteriks">*</span>}
        </label>
        <div className={inputClasses}>
          <input
            {...input}
            maxLength={maxLength}
            className="form__input"
            placeholder={placeholder}
            type={type}
            id={name}
            onBlur={onBlur}
            readOnly={readOnly}
          />
          {this.renderRevealIcon()}
          {meta.error && meta.touched &&
            <span className={errorClasses}>{meta.error}</span>
          }
        </div>
      </div>
    );
  }

  render() {
    const {
      name,
      label,
      labelSize,
      validatorsArray,
      maxLength,
      required,
      rowGap,
      placeholder,
      isRow,
      labelClass,
      inputClass,
      readOnly,
      errorPosition,
      asterisk,
    } = this.props;
    const labelClasses = classNames(
      'form__label',
      labelClass,
      {
        [`form__label_${labelSize}`]: Boolean(labelSize),
      }
    );
    const formRowClasses = classNames(
      'form__row',
      {
        [`form__row_gap_${rowGap}`]: Boolean(rowGap),
        row: Boolean(isRow),
      }
    );
    const inputClasses = classNames('form__error-wrap', inputClass);

    if (required) {
      validatorsArray.push(this.requiredValidator);
    }
    const errorClasses = classNames(
      'form__error',
      {
        [`form__error_${errorPosition.split(' ').join('_')}`]: Boolean(errorPosition),
      }
    );

    return (
      <Field
        name={name}
        validate={this.composeValidators(...validatorsArray)}
        component={this.renderFormRow}
        placeholder={placeholder}
        maxLength={maxLength}
        labelClasses={labelClasses}
        formRowClasses={formRowClasses}
        inputClasses={inputClasses}
        label={label}
        readOnly={readOnly}
        errorClasses={errorClasses}
        asterisk={asterisk}
        required={required}
      />
    );
  }
}
